import Link from "next/link";
import { ArrowUpRight } from "lucide-react";
import { categoryProducts, type CategoryId } from "@/lib/comparison-catalog";
import { categoryIcons } from "@/components/category-icons";
import { localizedCategories } from "@/lib/i18n/categories";
import { localePath, t, type Locale } from "@/lib/i18n";

/** Category tabs for the data pages; scrolls sideways on small screens. */
export function CategoryNav({ active, compare = false, locale = "es" }: { active: CategoryId; compare?: boolean; locale?: Locale }) {
  const copy = t(locale).catalog;
  return <nav className="vc-catnav" aria-label={copy.categoryNav}>
    {localizedCategories(locale).map(c => { const Icon = categoryIcons[c.id]; return <Link prefetch={false} aria-current={active === c.id ? "page" : undefined} key={c.id} href={localePath(locale, compare ? `/compare/${c.id}` : `/leaderboards/${c.id}`)}><Icon aria-hidden="true" />{c.label}<span className="vc-catnav-count">{categoryProducts(c.id).length}</span></Link>; })}
    <span className="vc-catnav-sep" aria-hidden="true" />
    <Link prefetch={false} href={localePath(locale, "/leaderboards/cloudops")}>{copy.cloudopsEditorial} <ArrowUpRight aria-hidden="true" /></Link>
  </nav>;
}
